<template>
  <div class="properties-centent kk-checkbox">
    <div class="properties-body">
      <a-row class="row">
        <a-col :span="12" class="title">
          周期
        </a-col>
        <a-col :span="12" style="text-align: right">
          <a-button class='button' type='primary' @click='handlePeriodEdit'>添加周期</a-button>
        </a-col>
      </a-row>
      <a-tree 
        show-line 
        :defaultExpandAll="true"
        v-if="projectVisitList.length > 0" 
        @select="onSelect">
        <a-icon slot="switcherIcon" type="down" />
        <a-tree-node 
          v-for="(projectVisit, projectVisitIndex) in projectVisitList" 
          :key="'period:_:' + projectVisit.id" 
          :title="projectVisit.name">
          <a-tree-node v-if="projectVisit.formList" v-for="(formList, formListIndex) in projectVisit.formList" :key="'form:_:' + formList.id" :title="formList.formName" />
        </a-tree-node>
      </a-tree>
      <br/>
      <hr/>
      <a-form-model layout="horizontal" :model="model" v-bind="{ labelCol: { span: 6 }, wrapperCol: { span: 18 }, }"
            ref="ruleForm" :rules="rules">
        <a-form-model-item label="科室" prop="deptId">
          <a-select placeholder="请选择科室" v-model="model.deptId" showSearch :filterOption="filterOption"
            @change="deptChange">
            <a-select-option :value="item.id" v-for="(item, index) in deptList" :key="index">{{ item.name
              }}</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="亚专业" prop="submajorId">
          <a-select placeholder="请选择亚专业" v-model="model.submajorId" showSearch :filterOption="filterOption"
            @change="subMajorChange">
            <a-select-option :value="item.id" v-for="(item, index) in subMajorList" :key="index">{{ item.name
              }}</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="病种" prop="diseaseId">
          <a-select placeholder="请选择病种" v-model="model.diseaseId" showSearch :filterOption="filterOption"
            @change="diseaseChange">
            <a-select-option :value="item.id" v-for="(item, index) in diseaseList" :key="index">{{ item.name
              }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item class="label" prop="name" label="方案名称">
          <a-input placeholder="请输入方案名称" v-model="model.name" class="input"/>
        </a-form-model-item>
        <a-form-model-item class="label" prop="remark" label="备注">
          <a-textarea :rows="4" placeholder="请输入备注" v-model="model.remark"  class="textarea"/>
        </a-form-model-item>
      </a-form-model>
    </div>

    <!--事件配置-->
    <CsimVisitPeriodModel ref="csimVisitPeriodModel" @close="modelClose"></CsimVisitPeriodModel>
  </div>
</template>
<script>

import {CACHE_PROJECT_ID} from '@/constants/project'
import Vue from 'vue'
import { getAction } from '@/api/manage'
import baseRules from '@/constants/baseRules'

import CsimVisitPeriodModel from './CsimVisitPeriodModel';

export default {
  name: "CsimVisitFormPeriod",
  components: {
    CsimVisitPeriodModel
  },
  props: {

  },
  data () {
    return {
      projectId: Vue.ls.get(CACHE_PROJECT_ID),
      projectVisitList: [],
      projectVisitListPages: 0,
      model: {},
      rules: {
        deptId: [baseRules.required],
        submajorId: [baseRules.required],
        diseaseId: [baseRules.required],
      },
      diseaseList: [],
      subMajorList: [],
      deptList: [],
    }
  },
  created () {
    this.getProjectVisitList();
    this.handleEditMy(this.model || {});
  },
  computed: {
    currentDeptOption() {
      // 根据value查找对应的选项对象
      return this.deptList.find(option => option.id === this.model.deptId);
    },
    currentSubMajorOption() {
      // 根据value查找对应的选项对象
      return this.subMajorList.find(option => option.id === this.model.submajorId);
    },
    currentDiseaseOption() {
      // 根据value查找对应的选项对象
      return this.diseaseList.find(option => option.id === this.model.diseaseId);
    },
  },
  methods: {
    getProjectVisitList() {
      getAction('/project/projectVisit/list', { 
        pageSize: 10, 
        column: "sortNum",
        order: "asc",
        projectId: this.projectId,
        field: "id,sortNum,name,formCount,formItem,status_dictText,description,action",
        pageNo: 1
      }).then(res => {
        if (res.success) {
          this.projectVisitList = res.result
          this.projectVisitListPages = res.result.pages
        } else {
          this.$message.error('后台请求异常')
        }
      })
    },
    onSelect(selectedKeys, info) {
      console.log('selected', selectedKeys, info);

      let itemId = selectedKeys[0];
      if (itemId.startsWith("form:_:")) {
        let formId = itemId.replace("form:_:", "");

        console.log("Form Id :", formId);

        for(let i = 0; i < this.projectVisitList.length; i++) {
          let projectVisit = this.projectVisitList[i];

          if (projectVisit.formList) {
            for (let j = 0; j < projectVisit.formList.length; j++) {
              let formVisit = projectVisit.formList[j];

              if (formVisit.id === formId) {
                this.$emit("handleSelectForm", formVisit)
                return;
              }
            }
          }
        }
      } else if (itemId.startsWith("period:_:")) {
        let periodId = itemId.replace("period:_:", "");

        console.log("Period Id :", periodId);

        for(let i = 0; i < this.projectVisitList.length; i++) {
          let projectVisit = this.projectVisitList[i];
          if (projectVisit.id === periodId) {
            this.$emit("handleSetPeriod", projectVisit)
            return;
          }
        }
      }
    },
    handlePeriodEdit() {
      this.$refs.csimVisitPeriodModel.visible = true;
    },
    modelClose(){
      // todo
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    initDisease() {
      getAction('/tempconfig/tempConfigDisease/list', { pageSize: 2000 }).then(res => {
        if (res.success) {
          this.diseaseList = res.result.records
          this.diseaseList.unshift({ "id": "0", "name": "所有病种" })
        } else {
          this.$message.error('后台请求异常')
        }
      })
    },
    initDept() {
      getAction('/tempconfig/tempConfigDept/list', { pageSize: 2000 }).then(res => {
        if (res.success) {
          this.deptList = res.result.records
          this.deptList.unshift({ "id": "0", "name": "所有科室" })
        } else {
          this.$message.error('后台请求异常')
        }
      })
    },
    initSubMajor() {
      getAction('/tempconfig/tempConfigSubmajor/list', { pageSize: 2000 }).then(res => {
        if (res.success) {
          this.subMajorList = res.result.records
          this.subMajorList.unshift({ "id": "0", "name": "所有亚专业" })
        } else {
          this.$message.error('后台请求异常')
        }
      })
    },
    handleEditMy(record) {
      const model = JSON.parse(JSON.stringify(record))
      this.model = model
      if (this.model.type == '2') {
        this.isVisible = false;
      } else {
        this.isVisible = true;
      }

      // this.initDisease()
      this.initDept()
      // this.initPeriod()
      // this.initSubMajor()

      this.deptChange()
      this.subMajorChange()
      // this.diseaseChange()

      if (this.model.id) {
        if (this.model.periodIdList && this.model.periodIdList.length > 0) {
          let periodList = []
          this.model.periodIdList.forEach(item => {
            periodList.push(item.id)
          })
          this.model.periodIdList = periodList
        }
      }
    },
    deptChange(vulue, option) {
      // let selectedOption = this.currentDeptOption;
      getAction('/tempconfig/tempConfigSubmajor/queryByDeptId', { id: this.model.deptId }).then(res => {
        if (res.success) {
          this.subMajorList = res.result
          this.subMajorList.unshift({ "id": "0", "name": "所有亚专业" })
        }
      })
    },
    subMajorChange(vulue, option) {
      // let selectedOption = this.currentSubMajorOption;
      // console.log(selectedOption)
      getAction('/tempconfig/tempConfigDisease/queryByDeptIdAndSubMajorId', { deptId: this.model.deptId, subMajorId: this.model.submajorId }).then(res => {
        if (res.success) {
          this.diseaseList = res.result
          this.diseaseList.unshift({ "id": "0", "name": "所有病种" })
        }
      })

    },
    diseaseChange(vulue, option) {
      if (this.model.type!='1') {
        // let selectedOption = this.currentDiseaseOption;
        if (this.model.diseaseId === "0") {
          this.model.moduleId = "0"
        } else {
          getAction('/tempconfig/tempConfigModule/queryByDiseaseId', { diseaseId: this.model.diseaseId }).then(res => {
            if (res.success) {
              this.model.moduleId = res.result.id
            }
          })
        }
      }
    },
  }
};
</script>
